import api from '@Services/api';
import { AxiosResponse } from 'axios';
import { UserPayload, RegisteredUser } from '../../Types/Webinar.types';

import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';

interface SlotCRUD extends CRUDBase<UserPayload, RegisteredUser> {}
export class RegisteredUsersRequester implements SlotCRUD {
	private static instance: RegisteredUsersRequester;
	static getInstance() {
		if (!RegisteredUsersRequester.instance) {
			RegisteredUsersRequester.instance = new RegisteredUsersRequester();
		}
		return RegisteredUsersRequester.instance;
	}
	baseURL = '/webinar/slot/users';
	getAll(
		payload?: GetAllMeta,
		id?: number
	): Promise<AxiosResponse<ApiResponse<RegisteredUser[]>>>;
	getAll(
		payload: number,
		id?: number
	): Promise<AxiosResponse<ApiResponse<RegisteredUser[]>>>;
	async getAll(
		payload?: any,
		id?: number
	): Promise<import('axios').AxiosResponse<ApiResponse<RegisteredUser[]>>> {
		return await api.post(`${this.baseURL}/fetch/${payload.id}`, payload);
		// return await api.post(`${this.baseURL}/fetch/2`, payload);
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<RegisteredUser>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<RegisteredUser>>>;
	get(
		id: string | number,
		payload: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<RegisteredUser>>>;
	async get(
		id: any,
		payload?: any
	): Promise<AxiosResponse<ApiResponse<RegisteredUser>>> {
		return await api.post(`/${this.baseURL}/get`, { id });
	}
	async create(
		payload: UserPayload
	): Promise<AxiosResponse<ApiResponse<RegisteredUser>>> {
		return await api.post(`${this.baseURL}/add`, payload);
	}
	async update(
		payload: UserPayload
	): Promise<AxiosResponse<ApiResponse<RegisteredUser>>> {
		return await api.put(`${this.baseURL}/update`, payload);
	}

	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<RegisteredUser>>>;
	async delete(
		id: any,
		payload?: any
	): Promise<AxiosResponse<ApiResponse<any>>> {
		return await api.delete(`${this.baseURL}/remove`, {
			data: payload,
		});
	}
}

export const changeUserSlot = async (
	from_slot_id: number,
	student_id: number,
	to_slot_id: number
) =>
	await api.post<ApiResponse<RegisteredUser>>('webinar/slot/users/change', {
		from_slot_id,
		student_id,
		to_slot_id,
	});

export const changeUserStatus = async (
	slot_id: number,
	student_id: number,
	status: string
) =>
	await api.post<ApiResponse<RegisteredUser>>(
		'webinar/slot/users/update/status',
		{
			slot_id,
			student_id,
			status,
		}
	);
